import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
} from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import * as XLSX from "xlsx";

import memberApi from "../../../apis/MemberManage.api";
import promotionApi from "../../../apis/Promotion.api";
import salesManageApi from "../../../apis/SalesManage.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import status from "../../../utils/status";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import OrderDetailComponent from "./OrderDetailComponent";

const dateTypeItems = [
  { label: "오늘", value: "today" },
  { label: "1주일", value: "1week" },
  { label: "1개월", value: "1month" },
  { label: "3개월", value: "3month" },
  { label: "6개월", value: "6month" },
];
const orderStatusItems = [
  { label: "전체", value: "total" },
  { label: "수락대기", value: "gift_address_ready" },
  { label: "수락취소", value: "gift_refusal" },
  { label: "수락완료", value: "gift_complete" },
];
const cancelReasonItems = [
  { label: "상품품절", value: "상품품절" },
  { label: "배송지연", value: "배송지연" },
  { label: "서비스 불만족", value: "서비스 불만족" },
  { label: "구매의사취소", value: "구매의사취소" },
  { label: "색상 및 사이즈 변경", value: "색상 및 사이즈 변경" },
  { label: "다른 상품 잘못 주문", value: "다른 상품 잘못 주문" },
  { label: "상품정보 상이", value: "상품정보 상이" },
];
const bankCodeItems = [
  { label: "KB국민은행", value: "04" },
  { label: "SC제일은행", value: "23" },
  { label: "경남은행", value: "39" },
  { label: "광주은행", value: "34" },
  { label: "기업은행", value: "03" },
  { label: "농협", value: "11" },
  { label: "대구은행", value: "31" },
  { label: "부산은행", value: "32" },
  { label: "산업은행", value: "02" },
  { label: "새마을금고", value: "45" },
  { label: "수협", value: "07" },
  { label: "신한은행", value: "88" },
  { label: "신협", value: "48" },
  { label: "외환은행", value: "81" },
  { label: "우리은행", value: "20" },
  { label: "우체국", value: "71" },
  { label: "전북은행", value: "37" },
  { label: "축협", value: "12" },
  { label: "카카오뱅크", value: "90" },
  { label: "케이뱅크", value: "89" },
  { label: "하나은행", value: "81" },
  { label: "한국씨티은행", value: "27" },
  { label: "토스뱅크", value: "92" },
];
const OrderGiftComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [mediaResult, setMediaResult] = useState(null);
  const [dateType, setDateType] = useState("1week");
  const [searchOptions, setSearchOptions] = useState({
    searchType: "order_created_at",
    searchStatus: "gift_address_ready",
    searchDetailType: "",
    searchDetail: "",
    searchOrderId: "",
    searchProductName: "",
    funnel: 0, // 유입경로
    name: "",
    phone: "",
    startDate: moment().subtract(7, "days").startOf("day"),
    endDate: moment().endOf("day"),
  });

  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [eachCount, setEachCount] = useState({
    giftAddressReadyCnt: 0,
    giftPaymentReadyCnt: 0,
    giftRefusalCnt: 0,
    giftCompleteCnt: 0,
  });

  const [totalOrderList, setTotalOrderList] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [editDeliveryInfo, setEditDeliveryInfo] = useState({});

  const [orderDetail, setOrderDetail] = useState({});
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [error, setError] = useState("");
  const [initialize, setInitialize] = useState(false);

  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      for (const row of selectedRows) {
        if (!editDeliveryInfo.hasOwnProperty(row.order_detail_id)) {
          editDeliveryInfo[row.order_detail_id] = {
            order_id: row.order_id,
            order_detail_id: row.order_detail_id,
            order_detail_status: "delivery_shipping",
            delivery_company: row.delivery_company,
            tracking_number: row.tracking_number,
            ship_date:
              row.ship_date === null || row.ship_date === ""
                ? moment()
                : moment(row.ship_date),
            updated_by: user.id === 724 ? 1 : user.id,
          };
        }
      }
      let difference = Object.keys(editDeliveryInfo).filter(
        (orderDetailKey) => !selectedRowKeys.includes(parseInt(orderDetailKey)),
      );
      if (difference?.length !== 0) {
        for (const orderDetailKey of difference) {
          delete editDeliveryInfo[orderDetailKey];
        }
      }
      setSelectedRowKey(selectedRowKeys);
      setSelectedRow(selectedRows);
    },
  };
  const columns = [
    {
      title: "주문번호",
      width: 80,
      dataIndex: "order_id",
      key: "order_id",
      ellipsis: true,
      align: "center",
      fixed: mediaResult ? "" : "left",
      render: (value, record) => {
        return (
          <span
            className="recommend-inquiry-list-title"
            onClick={() => {
              setOrderDetail(record);
              setIsOrderModalOpen(true);
            }}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "상품주문번호",
      width: 90,
      dataIndex: "order_detail_id",
      key: "order_detail_id",
      ellipsis: true,
      align: "center",
      fixed: mediaResult ? "" : "left",
    },
    {
      title: "주문일시",
      width: 130,
      dataIndex: "created_at",
      key: "created_at",
      ellipsis: true,
      align: "center",
      fixed: mediaResult ? "" : "left",
      render: (value) => {
        if (value !== null) {
          return moment(value).format("YYYY.MM.DD. HH:mm");
        }
      },
    },
    {
      title: "결제일",
      width: 130,
      dataIndex: "payment_created_at",
      key: "payment_created_at",
      ellipsis: true,
      align: "center",
      fixed: mediaResult ? "" : "left",
      render: (value) => {
        if (value !== null) {
          return moment(value).format("YYYY.MM.DD. HH:mm");
        }
      },
    },
    {
      title: "주문상태",
      width: 100,
      dataIndex: "order_detail_status",
      key: "order_detail_status",
      ellipsis: true,
      align: "center",
      fixed: mediaResult ? "" : "left",
      render: (value, row) => {
        if (value === "ready") {
          return "결제대기";
        } else if (
          value === "cancel_complete" ||
          value === "return_complete" ||
          value === "cancelled"
        ) {
          return "수락취소";
        } else if (value === "paid") {
          let gift_status = row.gift_status;
          if (gift_status === "address_ready") {
            return "수락대기";
          } else {
            return "수락완료";
          }
        } else {
          return "수락완료";
        }
      },
    },
    {
      title: "상품번호",
      // width: 200,
      dataIndex: "product_id",
      key: "product_id",
      ellipsis: true,
      align: "center",
    },
    {
      title: "상품명",
      width: 180,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
      align: "center",
    },
    {
      title: "옵션명",
      width: 200,
      dataIndex: "option_title",
      key: "option_title",
      ellipsis: true,
      align: "center",
    },
    {
      title: "수량",
      // width: 90,
      dataIndex: "quantity",
      key: "quantity",
      ellipsis: true,
      align: "center",
    },
    {
      title: "상품별 총 주문금액",
      width: 140,
      dataIndex: "total_price",
      key: "total_price",
      ellipsis: true,
      align: "center",
      render: (value) => {
        return value.toLocaleString();
      },
    },
    {
      title: "구매자명",
      width: 100,
      dataIndex: "gift_from_name",
      key: "gift_from_name",
      ellipsis: true,
      align: "center",
    },
    {
      title: "수취인명",
      width: 100,
      dataIndex: "gift_to_name",
      key: "gift_to_name",
      ellipsis: true,
      align: "center",
    },
    {
      title: "구매자 연락처",
      width: 140,
      dataIndex: "gift_from_phone",
      key: "gift_from_phone",
      ellipsis: true,
      align: "center",
    },
    {
      title: "수락기한",
      width: 120,
      dataIndex: "gift_to_date",
      key: "gift_to_date",
      ellipsis: true,
      align: "center",
      render: (value) => {
        if (value) {
          return moment(value).format("YYYY.MM.DD");
        }
      },
    },
    {
      title: "배송지 입력 안내",
      width: 120,
      dataIndex: "gift_to_date",
      key: "gift_to_date",
      ellipsis: true,
      align: "center",
      fixed: "right",
      render: (value, record) => {
        let buttonActive = false;
        if (record.order_detail_status === "paid") {
          let gift_status = record.gift_status;
          if (gift_status === "address_ready") {
            buttonActive = true;
            // return "수락대기";
          }
          // else {
          // 	buttonActive = true;
          // 	// return "수락완료";
          // }
        }
        if (value) {
          let leftDays = moment(value).diff(moment(), "days");
          if (leftDays >= 0) {
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  justifyContent: "center",
                }}
              >
                <span>D-{leftDays > 0 ? leftDays : "Day"}</span>
                {buttonActive && (
                  <Button
                    // size={"middle"}
                    onClick={() => crmMessageResend(record)}
                  >
                    재발송
                  </Button>
                )}
              </div>
            );
          }
        }
      },
    },
  ];

  useEffect(() => {
    if (typeof window !== "undefined") {
      const matchQueryList = window.matchMedia("all and (max-width: 768px)");
      setMediaResult(matchQueryList.matches);

      const media = function handleChange(e) {
        setMediaResult(e.matches);
      };

      matchQueryList.addEventListener("change", media);
    }
    getUserOrderGiftList();
  }, []);

  useEffect(() => {
    setOrderList(totalOrderList.slice(offset, offset + pageSize));
  }, [offset, pageSize]);

  useEffect(() => {
    handleChangePagination(currentPageNumber);
  }, [pageSize]);

  /**
   * 선물 수락대기 리스트 가져오기 -> userOrderDetailList 와 동일
   * @type {(function(): Promise<void>)|*}
   */
  const getUserOrderGiftList = async () => {
    try {
      setIsLoading(true);
      const param = {
        pageType: "giftReady",
        searchType: "order_created_at", // payment_created_at | order_created_at
        // startDate: moment()
        // 	.subtract(14, "days")
        // 	.startOf("day")
        // 	.format("YYYYMMDDHHmm"),
        // endDate: moment().endOf("day").format("YYYYMMDDHHmm"),
        startDate: searchOptions.startDate
          ?.startOf("day")
          .format("YYYYMMDDHHmm"),
        endDate: searchOptions.endDate?.endOf("day").format("YYYYMMDDHHmm"),
        searchStatus: searchOptions.searchStatus,
        searchOrderId: searchOptions.searchOrderId,
        searchProductName: searchOptions.searchProductName,
        phone: searchOptions.phone.includes("-")
          ? searchOptions.phone.replaceAll("-", "")
          : searchOptions.phone,
        name: searchOptions.name,
        orderType: "order_id", // payment_created_at | created_at | order_id
        orderBy: "desc",
        userId: user.id === 724 ? 1 : user.id,
      };
      const res = await salesManageApi.searchOrderGiftList(param);
      const rsp = await salesManageApi.salesManageStatus(param);
      if (res.code === 200) {
        setTotalSize(res.result?.totalCnt ?? 0);
        setTotalOrderList(res.result?.userOrderDetailDTOList ?? []);
        setOrderList(res.result.userOrderDetailDTOList.slice(0, 10));
      }
      if (rsp.code === 200) {
        setEachCount({
          giftAddressReadyCnt: rsp.result?.giftAddressReadyCnt ?? 0,
          giftPaidReadyCnt: rsp.result?.giftPaidReadyCnt ?? 0,
          giftRefusalCnt: rsp.result?.giftRefusalCnt ?? 0,
          giftCompleteCnt: rsp.result?.giftCompleteCnt ?? 0,
        });
        console.log(rsp.result);
      }
    } catch (e) {
      console.log("[OrderGiftComponent] getUserOrderGiftList===", e);
    }
    setIsLoading(false);
  };

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    try {
      setIsLoading(true);
      let excelData;
      if (selectedRow?.length !== 0) {
        excelData = selectedRow.map((row) => {
          // let commission_dy = row.is_cooperate
          // 	? 0
          // 	: Math.round(row.total_price * 0.11);
          // let commission_sell = row.query
          // 	? row.is_cooperate
          // 		? Math.round(
          // 				row.total_price * ((row.cooperate_fee_rate * 1.1) / 100)
          // 		  )
          // 		: Math.round(
          // 				row.total_price * ((row.commission_rate * 1.1) / 100)
          // 		  )
          // 	: 0;

          // row.is_influencer
          //     ? Math.round(row.total_price * (row.influencer_fee_rate / 100)) : 0
          // let profit_price = row.total_price;
          // if (row.query) {
          // 	if (row.is_cooperate) {
          // 		profit_price =
          // 			profit_price -
          // 			Math.round(
          // 				row.total_price * ((row.cooperate_fee_rate * 1.1) / 100),
          // 			);
          // 	} else {
          // 		profit_price =
          // 			profit_price -
          // 			Math.round(
          // 				row.total_price * ((row.commission_rate * 1.1) / 100),
          // 			);
          // 		profit_price = profit_price - Math.round(row.total_price * 0.11);
          // 	}
          // } else {
          // 	profit_price = profit_price - Math.round(row.total_price * 0.11);
          // }
          // let purchase_path = "";
          // if (row.query) {
          // 	if (row.is_cooperate) {
          // 		purchase_path = "공동구매";
          // 	} else {
          // 		purchase_path = "인플루언서";
          // 	}
          // } else {
          // 	purchase_path = "검색";
          // }
          console.log(row.order_detail_status);
          return {
            order_id: `DY${row.order_id}`,
            order_detail_id: `dy${row.order_detail_id}`,
            created_at: row.created_at,
            payment_created_at: moment(row.payment_created_at).format(
              "YYYY.MM.DD HH:mm",
            ),
            order_detail_status:
              status.matchingOrderStatus[row.order_detail_status],
            product_id: row.product_id,
            product_name: row.product_name,
            // option_id: row.option_id,
            option_title: row.option_title,
            quantity: row.quantity,
            total_price: row.total_price,
            price: row.price,
            coupon_discount_price: row.coupon_discount_price,
            gift_from_name: row.gift_from_name,
            gift_to_name: row.gift_to_name,
            gift_from_phone: row.gift_from_phone,
            gift_to_date: moment(row.gift_to_date).format("YYYY.MM.DD HH:mm"),
            // use_point: row.use_point ? "Y" : "N",
            // name: row.name,
            // phone: row.phone,
            // address:
            // 	row.address +
            // 	(row.address_detail ? `, ${row.address_detail}` : ""),
            // address_request:
            // 	row.address_request === "배송 시 요청사항을 선택해주세요."
            // 		? ""
            // 		: row.address_request,
            // delivery_company: status.matchingDeliveryCompany[
            // 	row.delivery_company
            // ]
            // 	? status.matchingDeliveryCompany[row.delivery_company]
            // 	: row.delivery_company,
            // tracking_number: row.tracking_number,
            // ship_date: row.ship_date
            // 	? moment(row.ship_date).format("YYYY.MM.DD")
            // 	: row.ship_date,
            // purchase_path: purchase_path,
            // commission_dy: commission_dy,
            // commission_sell: commission_sell,
            // profit_price: profit_price,
          };
        });
      } else {
        alert(
          "다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.",
        );
        throw "no data";
      }
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      Object.keys(excelData[0]).forEach((key, idx) => {
        const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 });
        ws[cellAdd].v = status.matchingKey[key];
      });
      XLSX.utils.book_append_sheet(wb, ws, "선물수락대기");
      // 닥터체크 사용자일 경우, 주문목록 엑셀 다운시, 택배사 시트 추가
      // if (user && user.id === 4) {
      // 	const ws_delivery = XLSX.utils.json_to_sheet(
      // 		deliveryCompanyList.map((delivery) => {
      // 			return {
      // 				택배사명: delivery.delivery_company_name,
      // 			};
      // 		})
      // 	);
      // 	XLSX.utils.book_append_sheet(wb, ws_delivery, "택배사");
      // }
      XLSX.writeFile(wb, `${moment().format("YYYYMMDD")}_선물수락대기.xlsx`);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      if (error !== "no data") {
        alert(error);
      }
      console.log("handleExcelDownloadClick edit error", error);
    }
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(currOffset);
  };

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset((current - 1) * pageSize);
  };

  /**
   * 주문 상세 Modal cancel handler
   */
  const handleOrderDetailModalCancel = () => {
    setIsOrderModalOpen(false);
    setOrderDetail({});
  };
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
    }
  };

  /**
   * 검색
   */
  const handleSearch = () => {
    setOffset(0);
    setCurrentPageNumber(1);
    setSelectedRowKey([]);
    setSelectedRow([]);
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          "조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.",
        );
      } else {
        getUserOrderGiftList();
      }
    }
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      // searchType: searchDateItems[0].searchType,
      searchType: "order_created_at",
      // searchStatus: orderStatusItems[0].value,
      searchStatus: "gift_address_ready",
      searchOrderId: "",
      searchProductName: "",
      funnel: 0,
      name: "",
      phone: "",
      startDate: moment().subtract(7, "days").startOf("day"),
      endDate: moment().endOf("day"),
    });
    setDateType("1week");
    setOffset(0);
    setPageSize(10);
    setSelectedRowKey([]);
    setSelectedRow([]);
    setInitialize(true);
    // setTimeout(() => {
    // 	handleSearch();
    // }, 200);
    // return () => clearTimeout(debounce);
  };

  const crmMessageResend = async (record) => {
    if (
      confirm(
        `받는 분: ${record.gift_to_name}\n연락처: ${record.gift_to_phone}\n배송지 입력 안내 카카오톡을 전송하시겠습니까?`,
      )
    ) {
      let param = {
        // gift_to_name: record.gift_to_name,
        // gift_to_phone: record.gift_to_phone,
        orderIdList: [record.order_id],
        created_by: user?.id === 724 ? 1 : user?.id,
      };
      const res = await memberApi.postGiftCrmReSend(param);
      if (res.code === 200) {
        alert("성공적으로 재발송 되었습니다.");
      } else {
        if (res.msg) {
          alert(res.msg);
        } else {
          alert("재발송이 실패하였습니다.");
        }
      }
    }
  };

  useEffect(() => {
    if (initialize) {
      getUserOrderGiftList();
      setInitialize(false);
    }
  }, [searchOptions, initialize]);

  // console.log(searchOptions?.searchStatus);

  const disabledAdminCancelComplete = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      let orderId = 0;
      let validList = [];
      for (let i = 0; i < selectedRow?.length; i++) {
        const row = selectedRow[i];
        if (i === 0) {
          orderId = row.order_id;
          if (row.hasOwnProperty("is_deposit") && row.is_deposit) {
            validList.push(false);
          } else {
            if (row.order_detail_status === "paid") {
              validList.push(true);
            } else {
              validList.push(false);
            }
          }
        } else {
          if (row.order_id !== orderId) {
            validList.push(false);
          } else {
            if (row.hasOwnProperty("is_deposit") && row.is_deposit) {
              validList.push(false);
            } else {
              if (row.order_detail_status === "paid") {
                validList.push(true);
              } else {
                validList.push(false);
              }
            }
          }
        }
      }
      return !validList.every((result) => result);
    }
  };
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [editCancelReason, setEditCancelReason] = useState({
    cancel_reason: null,
    refund_bank: null,
  });
  const [isCancelRequestModalOpen, setIsCancelRequestModalOpen] =
    useState(false);

  const orderDirectlyCancel = async () => {
    setIsLoading(true);
    try {
      // 부분환불처리시 포인트 사용 주문에 관한 부분환불은 추가 로직이 필요함.
      // 회사 입장에서 포인트를 먼저 돌려주는 것이 더 이득임.
      if (selectedRow[0].use_point !== null) {
        const isLastOrderParam = {
          id: selectedRow[0].order_id,
          orderDetailIdList: selectedRowKey,
        };
        const isLastOrderRes = await salesManageApi.isLastOrderByOrderId(
          isLastOrderParam,
        );
        if (isLastOrderRes.result?.length !== 0) {
          throw `해당 주문은 포인트를 사용힌 주문이라 부분 환불이 불가합니다.\n선택한 주문번호와 동일한 모든 것들을 한번에 선택해서 다시 시도하거나 해당 주문번호와 함께 관리자에게 문의해주시길 바랍니다.`;
        }
      }
      let orderDetailIdList = [];
      let totalSum = 0;
      for (const row of selectedRow) {
        orderDetailIdList.push(row.order_detail_id);
        totalSum += row.total_price;
      }
      const param = {
        id: selectedRow[0].order_id,
        orderDetailIdList: orderDetailIdList,
        cancel_request_amount: totalSum,
      };
      console.log("orderDirectlyCancel", param);
      const res = await salesManageApi.refundableOrder(param);
      console.log("refundableOrder", res);
      if (res.code === 200) {
        if (res.result) {
          if (
            window.confirm(
              `주문번호: ${selectedRow[0].order_id} 인 주문건에 대한 환불처리가 가능합니다.\n확인을 눌러 환불처리를 이어서 진행해주세요.`,
            )
          ) {
            setIsCancelModalOpen(true);
          }
        } else {
          alert(
            "해당 주문건을 취소하는데 추가 결제 금액이 발생합니다.\n구매자분께서 추가 결제를 진행할 수 있도록 안내 메시지 작성을 부탁드립니다.",
          );
          setEditCancelReason({
            ...editCancelReason,
            cancel_reason: "추가 결제 금액 발생",
            refund_bank: null,
          });
          setIsCancelRequestModalOpen(true);
        }
      } else {
        throw res.msg;
      }
    } catch (e) {
      setIsLoading(false);
      setError(error);
      console.log("orderDirectlyCancel error", e);
      alert(e);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 구매자에게 취소 요청 보내기 Modal click cancel handler
   */
  const handelRequestModalCancel = () => {
    setEditCancelReason({ cancel_reason: null, refund_bank: null });
    setSelectedRow([]);
    setSelectedRowKey([]);
    setIsCancelRequestModalOpen(false);
  };

  /**
   * 판매자 직접취소 처리 validation
   */
  const handleSellerCancelValidation = () => {
    if (selectedRow[0].pay_method === "vbank") {
      if (
        editCancelReason.hasOwnProperty("cancel_reason") &&
        editCancelReason.cancel_reason !== null &&
        editCancelReason.cancel_reason !== "" &&
        editCancelReason.hasOwnProperty("refund_holder") &&
        editCancelReason.refund_holder !== null &&
        editCancelReason.refund_holder !== "" &&
        editCancelReason.refund_holder === selectedRow[0].name &&
        editCancelReason.hasOwnProperty("refund_bank") &&
        editCancelReason.refund_bank !== null &&
        editCancelReason.refund_bank !== "" &&
        editCancelReason.hasOwnProperty("refund_account") &&
        editCancelReason.refund_account !== null &&
        editCancelReason.refund_account !== "" &&
        /^(\s|\d)+$/.test(editCancelReason.refund_account)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        editCancelReason.hasOwnProperty("cancel_reason") &&
        editCancelReason.cancel_reason !== null &&
        editCancelReason.cancel_reason !== ""
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  /**
   * 구매자에게 취소 요청 보내기 Modal ok handler
   */
  const handleRequestModalOk = async () => {
    setIsLoading(true);
    try {
      const valid = handleSellerCancelValidation();
      if (valid) {
        for (const row of selectedRow) {
          const cancelInfo = {
            order_id: row.order_id,
            order_detail_id: row.order_detail_id,
            order_detail_status: "cancel_request",
            cancel_reason: editCancelReason.cancel_reason,
            cancel_reason_detail:
              editCancelReason.hasOwnProperty("cancel_reason_detail") &&
              editCancelReason.cancel_reason_detail !== null &&
              editCancelReason.cancel_reason_detail !== ""
                ? editCancelReason.cancel_reason_detail
                : "",
            cancel_target: "admin",
            refund_holder: "",
            refund_bank: "",
            refund_account: "",
            updated_by: user.id === 724 ? 1 : user.id,
          };
          const cancelRes = await salesManageApi.orderCancelInfoEdit(
            cancelInfo,
          );
          if (cancelRes.code !== 200) {
            setTimeout(() => {
              handelRequestModalCancel();
            }, 1000);
            if (cancelRes.code === 999) {
              throw cancelRes.msg;
            } else {
              throw `해당 주문건에 대한 정보를 저장하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
            }
          }
        }
        alert("해당 내용을 성공적으로 요청완료했습니다.");
        getUserOrderGiftList();
      } else {
        throw "필수값이 채워지지 않았거나 원하는 형식과 다릅니다.\n다시 시도해주시길 바랍니다.";
      }
      setIsLoading(false);
      setTimeout(() => {
        handelRequestModalCancel();
      }, 1000);
    } catch (e) {
      setIsLoading(false);
      setError(error);
      console.log("handleRequestModalOk error", e);
      alert(e);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 판매자 직접취소 처리 Modal click cancel handler
   */
  const handelSellerModalCancel = () => {
    setEditCancelReason({ cancel_reason: null, refund_bank: null });
    setSelectedRow([]);
    setSelectedRowKey([]);
    setIsCancelModalOpen(false);
  };

  /**
   * 판매자 직접취소 처리 Modal click ok handler
   */
  const handleSellerModalOk = async () => {
    setIsLoading(true);
    try {
      const valid = handleSellerCancelValidation();
      if (valid) {
        let totalPriceSum = 0;
        let cancelInfoList = [];
        let cancelCouponIdList = [];
        let cancelParam = {};
        let cancelPointParam = {};
        const sellerIdList = [
          ...new Set(selectedRow.map((row) => row.seller_id)),
        ];
        console.log("sellerIdList", sellerIdList);
        for (const sellerId of sellerIdList) {
          const orderBySeller = selectedRow.filter(
            (row) => row.seller_id === sellerId,
          );
          let isLastOrderParam = {
            seller_id: sellerId,
            id: orderBySeller[0].order_id,
            orderDetailIdList: orderBySeller.map(
              (order) => order.order_detail_id,
            ),
          };
          console.log("isLastOrder", isLastOrderParam);
          const isLastOrderRes = await salesManageApi.isLastOrder(
            isLastOrderParam,
          );
          console.log("isLastOrderRes", isLastOrderRes);
          if (isLastOrderRes.code !== 200) {
            throw `서버 오류로 해당 사항을 진행할 수 없습니다. 해당 오류가 계속해서 발생한다면 관리자에게 문의바랍니다.`;
          }
          for (const order of orderBySeller) {
            totalPriceSum += order.total_price;
            if (order.coupon_id !== null && order.coupon_id !== "ADMIN") {
              cancelCouponIdList.push(order.coupon_id);
            }
            const cancelInfo = {
              order_id: order.order_id,
              order_detail_id: order.order_detail_id,
              order_detail_status: "cancel_complete",
              cancel_reason: editCancelReason.cancel_reason,
              cancel_reason_detail:
                editCancelReason.hasOwnProperty("cancel_reason_detail") &&
                editCancelReason.cancel_reason_detail !== null &&
                editCancelReason.cancel_reason_detail !== ""
                  ? editCancelReason.cancel_reason_detail
                  : "",
              cancel_target: "admin",
              refund_holder:
                editCancelReason.hasOwnProperty("refund_holder") &&
                editCancelReason.refund_holder !== null &&
                editCancelReason.refund_holder !== ""
                  ? editCancelReason.refund_holder
                  : "",
              refund_bank:
                editCancelReason.hasOwnProperty("refund_bank") &&
                editCancelReason.refund_bank !== null &&
                editCancelReason.refund_bank !== ""
                  ? editCancelReason.refund_bank
                  : "",
              refund_account:
                editCancelReason.hasOwnProperty("refund_account") &&
                editCancelReason.refund_account !== null &&
                editCancelReason.refund_account !== ""
                  ? editCancelReason.refund_account
                  : "",
              updated_by: user.id === 724 ? 1 : user.id,
            };
            cancelInfoList.push(cancelInfo);
          }
          if (isLastOrderRes.result?.length === 0) {
            if (
              orderBySeller[0].delivery_price_baseline !== null &&
              totalPriceSum < orderBySeller[0].delivery_price_baseline
            ) {
              totalPriceSum += orderBySeller[0].delivery_price;
            }
          } else {
            let remainPriceSum = 0;
            for (const order of isLastOrderRes.result) {
              remainPriceSum += order.total_price;
            }
            if (
              orderBySeller[0].delivery_price_baseline !== null &&
              remainPriceSum < orderBySeller[0].delivery_price_baseline
            ) {
              totalPriceSum -= orderBySeller[0].delivery_price;
            }
          }
        }
        // 포인트 환급
        if (selectedRow[0].use_point !== null) {
          console.log("마지막 주문입니다!!!", selectedRow[0]);
          cancelPointParam = {
            totalOrder: {
              id: selectedRow[0].order_id,
              order_status: "cancel_complete",
            },
          };
          totalPriceSum -= selectedRow[0].use_point;
        }
        if (selectedRow[0].pay_method === "vbank") {
          cancelParam = {
            merchant_uid: selectedRow[0].order_id,
            imp_uid: selectedRow[0].imp_uid,
            reason: `[${editCancelReason.cancel_reason}] ${
              editCancelReason.cancel_reason_detail
                ? editCancelReason.cancel_reason_detail
                : ""
            }`,
            cancel_request_amount: totalPriceSum,
            refund_holder: editCancelReason.refund_holder,
            refund_bank: editCancelReason.refund_bank,
            refund_account: editCancelReason.refund_account,
            userOrderDetailList: selectedRow,
          };
        } else {
          cancelParam = {
            merchant_uid: selectedRow[0].order_id,
            imp_uid: selectedRow[0].imp_uid,
            reason: `[${editCancelReason.cancel_reason}] ${
              editCancelReason.cancel_reason_detail
                ? editCancelReason.cancel_reason_detail
                : ""
            }`,
            cancel_request_amount: totalPriceSum,
            // cancelableAmount: row.total_price
            userOrderDetailList: selectedRow,
          };
        }
        console.log("cancelParam", cancelParam);
        const res = await salesManageApi.orderDirectlyCancel(cancelParam);
        if (res.code === 203) {
          console.log(
            "판매자 직접취소처리 cancelCouponIdList",
            cancelCouponIdList,
          );
          if (cancelCouponIdList?.length !== 0) {
            const cancelCoupon = {
              couponIdList: cancelCouponIdList,
              user_coupon_is_available: true,
              user_id: selectedRow[0].created_by,
              created_by: user.id === 724 ? 1 : user.id,
            };
            const cancelCouponRes = await promotionApi.userCouponChangeStatus(
              cancelCoupon,
            );
            console.log("판매자 직접취소처리 cancelCoupon", cancelCouponRes);
            if (cancelCouponRes.code !== 200) {
              throw `해당 주문건에 대한 쿠폰 정보를 수정하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
            }
          }
          // 포인트 환급
          if (Object.keys(cancelPointParam)?.length !== 0) {
            console.log("sdsadad", cancelPointParam);
            const cancelPointRes = await salesManageApi.purchasePointCancel(
              cancelPointParam,
            );
            console.log("포인트 환급 결과 ===", cancelPointRes);
            if (cancelPointRes.code !== 200) {
              throw `해당 주문건에서 사용한 포인트를 환급하는 과정에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
            }
          }
          for (const cancelInfo of cancelInfoList) {
            const cancelRes = await salesManageApi.orderCancelInfoEdit(
              cancelInfo,
            );
            if (cancelRes.code !== 200) {
              setTimeout(() => {
                handelSellerModalCancel();
              }, 1000);
              if (cancelRes.code === 999) {
                throw cancelRes.msg;
              } else {
                throw `해당 주문건에 대한 정보를 저장하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
              }
            }
          }
        } else {
          setTimeout(() => {
            handelSellerModalCancel();
          }, 1000);
          throw `해당 주문건을 환불하는데 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
        }
        alert("해당 내용이 성공적으로 반영되었습니다.");
        getUserOrderGiftList();
      } else {
        throw "필수값이 채워지지 않았거나 원하는 형식과 다릅니다.\n다시 시도해주시길 바랍니다.";
      }
      setIsLoading(false);
      setTimeout(() => {
        handelSellerModalCancel();
      }, 1000);
    } catch (e) {
      setIsLoading(false);
      setError(error);
      console.log("handleSellerModalOk error", e);
      alert(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ContentHeaderComponent title="선물하기 관리" />
      <div className="product-register-wrap">
        {/* 상단 안내 */}
        <div className={`commission-information`}>
          <div
            className={`commission-information-sentences`}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <p style={{ fontWeight: "600" }}>
              선물하기를 통한 주문으로 수신자가 선물 수락을 하지 않은 상태의
              주문을 확인하실 수 있습니다.
            </p>
            <p>
              · <span>수락대기</span>:{" "}
              <span>수신자가 선물을 수락하지 않은 상태</span>이며, 수락기한 내
              수락하지 않을 시 주문은 자동 취소됩니다.
            </p>
            <p>
              · <span>수락취소</span>:{" "}
              <span>구매자 혹은 수신자에 의해 취소가 진행된 상태</span>이며,
              배송지 미입력 자동 취소/구매자 취소/반품 완료 진행된 주문
              내역입니다.
            </p>
            <p>
              · <span>수락완료</span>:{" "}
              <span>결제가 완료 된 후 수락이 완료된 상태</span>이며, 결제완료,
              배송 준비중, 배송 중, 배송 완료, 구매 확정, 취소 요청, 반품 완료를
              제외한 나머지 반품 과정에 대한 주문 내역 입니다.
            </p>
            <p>
              · 배송상품은 수락 시 수신자가 배송지를 입력 또는 확정하므로
              수락대기 상태일 때에는 발주/발송할 수 없습니다.
            </p>
            <p>
              · 수락기한 내 배송지가 입력 또는 확정되면 발주확인/발송관리 메뉴로
              이동하며, 주문 확인 후 발송처리를 진행하시면 됩니다.
            </p>
            <p>
              <span>
                · 선물하기 주문은 구매자 결제 이후, 선물 수신자가 배송지 정보를
                입력하거나 변경하는 형태
              </span>
              이며, 제주/도서산간지역 추가배송비는 적용되지 않습니다.
            </p>
          </div>
        </div>

        {/* 수락대기 데이터 조회 */}
        <Row className="product-search-product-status-wrap">
          {/* 수락대기 */}
          <Col span={8} md={5}>
            <Row className="product-status-box-wrap">
              <img
                className="product-status-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/product/total_product.png`}
                alt={"선물하기 상태"}
              />
              <div className="product-status-text">
                <div>수락대기</div>
                <div>
                  <span className="product-status-num">
                    {eachCount.giftAddressReadyCnt?.toLocaleString()}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </Col>

          {/* 수락취소 */}
          <Col span={8} md={5}>
            <Row className="product-status-box-wrap">
              <img
                className="product-status-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/product/total_product.png`}
                alt={"선물하기 상태"}
              />
              <div className="product-status-text">
                <div>수락취소</div>
                <div>
                  <span className="product-status-num">
                    {eachCount.giftRefusalCnt?.toLocaleString()}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </Col>

          {/* 수락완료 */}
          <Col span={8} md={5}>
            <Row className="product-status-box-wrap">
              <img
                className="product-status-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/product/total_product.png`}
                alt={"선물하기 상태"}
              />
              <div className="product-status-text">
                <div>수락완료</div>
                <div>
                  <span className="product-status-num">
                    {eachCount.giftCompleteCnt?.toLocaleString()}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </Col>
        </Row>

        <div className="product-search-box-wrap">
          <Form.Item
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align={"middle"} style={{ gap: "5px" }}>
              <Radio.Group
                className={`options-list`}
                options={dateTypeItems}
                onChange={handleDateTypeChange}
                value={dateType}
                optionType="button"
              />
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.startDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, startDate: value });
                }}
              />
              ~
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.endDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, endDate: value });
                }}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="주문상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchStatus}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchStatus: value })
              }
              style={{ width: 250, textAlign: "left" }}
            >
              {orderStatusItems.map((item, idx) => (
                <Option key={`order_status_search_${idx}`} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle">
              <Col sm={5} md={2}>
                <div className="content-search-wrap">주문번호</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchOrderId"
                  value={searchOptions.searchOrderId}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">상품명</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchProductName"
                  value={searchOptions.searchProductName}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
            <Row align="middle" style={{ marginTop: 10 }}>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">이름</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">연락처</div>
              </Col>
              <Col>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="product-search-button-wrap" justify="center">
            <Button
              className="product-search-button search"
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className="product-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*주문검색목록*/}
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
          style={{ marginTop: 20 }}
        >
          <div
            style={{
              display: "flex",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <span className="product-register-box-title">
              목록 (총{" "}
              <span
                className="product-register-box-subtitle"
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <Button
              className="order-status-change-button"
              disabled={disabledAdminCancelComplete()}
              onClick={() => orderDirectlyCancel()}
            >
              판매자 직접취소 처리
            </Button>
          </div>
          <div>
            <Button
              className="order-excel-download-btn"
              icon={
                <img
                  style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`}
                />
              }
              onClick={handleExcelDownloadClick}
            >
              엑셀다운
            </Button>
          </div>
        </Row>
        <div
          className="product-register-border-box"
          style={{
            borderTop: 0,
            padding: "20px 25px 40px",
            height: "fit-content",
          }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={orderList}
            loading={isLoading}
            // tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="order_detail_id"
            rowClassName="coupon-table-row"
            // scroll={{x: 'calc(700px + 50%)'}}
            scroll={{ x: "max-content" }}
            // onChange={tableOnChange}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showSizeChanger
              pageSize={pageSize}
              onShowSizeChange={pageSizeChange}
              total={totalSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>

        {/*주문 상세 페이지*/}
        {isOrderModalOpen && (
          <Modal
            title="상품주문정보 조회"
            wrapClassName="order-detail-modal-wrap"
            visible={isOrderModalOpen}
            centered={true}
            onCancel={handleOrderDetailModalCancel}
            footer={null}
            width="60%"
          >
            <OrderDetailComponent
              orderDetail={orderDetail}
              handleOrderDetailModalCancel={handleOrderDetailModalCancel}
              getUserOrderGiftList={getUserOrderGiftList}
            />
          </Modal>
        )}
        {isCancelModalOpen && (
          <Modal
            title="선택건 판매취소"
            visible={isCancelModalOpen}
            onCancel={handelSellerModalCancel}
            onOk={handleSellerModalOk}
            cancelText={<span>닫기</span>}
            okText={<span>선택건 판매취소</span>}
            confirmLoading={isLoading}
            width={"50%"}
          >
            <Form.Item
              label="판매 불가 사유"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Select
                placeholder="선택"
                value={editCancelReason.cancel_reason}
                onChange={(value) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    cancel_reason: value,
                  })
                }
                style={{ width: 250, textAlign: "left" }}
              >
                {cancelReasonItems.map((item, idx) => (
                  <Option key={`order_cancel_reason_${idx}`} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="구매자에게 전하실 말씀"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input.TextArea
                className="order-modal-address-request-wrap"
                name="cancel_reason_detail"
                value={editCancelReason.cancel_reason_detail}
                onChange={(e) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    [e.target.name]: e.target.value,
                  })
                }
                rows={5}
              />
            </Form.Item>
            {selectedRow?.length !== 0 &&
              selectedRow[0].pay_method === "vbank" && (
                <>
                  <Form.Item
                    label="예금주"
                    labelAlign="left"
                    colon={false}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    required
                  >
                    <Input
                      placeholder="주문자명과 동일한 예금주명을 입력해주세요"
                      name="refund_holder"
                      value={editCancelReason.refund_holder}
                      onChange={(e) =>
                        setEditCancelReason({
                          ...editCancelReason,
                          [e.target.name]: e.target.value,
                        })
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    label="환불 은행"
                    labelAlign="left"
                    colon={false}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    required
                  >
                    <Select
                      placeholder="환불 은행을 선택해주세요"
                      value={editCancelReason.refund_bank}
                      onChange={(value) =>
                        setEditCancelReason({
                          ...editCancelReason,
                          refund_bank: value,
                        })
                      }
                    >
                      {bankCodeItems.map((item, idx) => (
                        <Option key={`bank_code_${idx}`} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="계좌번호"
                    labelAlign="left"
                    colon={false}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    required
                  >
                    <Input
                      placeholder={`"-"없이 계좌번호 숫자를 입력해주세요`}
                      name="refund_account"
                      value={editCancelReason.refund_account}
                      onChange={(e) =>
                        setEditCancelReason({
                          ...editCancelReason,
                          [e.target.name]: e.target.value,
                        })
                      }
                    />
                  </Form.Item>
                </>
              )}
          </Modal>
        )}

        {/*구매자에게 취소 요청 보내기*/}
        {isCancelRequestModalOpen && (
          <Modal
            title="선택건 판매취소요청"
            visible={isCancelRequestModalOpen}
            onCancel={handelRequestModalCancel}
            onOk={handleRequestModalOk}
            cancelText={<span>닫기</span>}
            okText={<span>확인</span>}
            confirmLoading={isLoading}
            width={"50%"}
          >
            <Form.Item
              label="취소 불가 사유"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="cancel_reason"
                value={editCancelReason.cancel_reason}
                onChange={(e) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    [e.target.name]: e.target.value,
                  })
                }
              />
            </Form.Item>
            <Form.Item
              label="구매자에게 전하실 말씀"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input.TextArea
                className="order-modal-address-request-wrap"
                name="cancel_reason_detail"
                value={editCancelReason.cancel_reason_detail}
                onChange={(e) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    [e.target.name]: e.target.value,
                  })
                }
                rows={5}
              />
            </Form.Item>
          </Modal>
        )}
      </div>
    </>
  );
};

export default OrderGiftComponent;
